import { DefaultService } from '@/services/DefaultService';

/* @71139 */
export default class NivelTecnologicoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(agroniveltecnologico) {
        return this._http.post(`${this._env}/agro/agro-niveltecnologico`, agroniveltecnologico, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/agro-niveltecnologico/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, params) {
        return this._http.get(encodeURI(`${this._env}/agro/agro-niveltecnologico.json?page=${page}&limit=${limit}&situacao=${situacao}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(agroniveltecnologico) {
        return this._http.post(`${this._env}/agro/agro-niveltecnologico/updatesituacao`, agroniveltecnologico, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findEmpresa() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-niveltecnologico/empresa?`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    loadSafra(limit = 50, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/safra/getcombo.json?limit=${limit}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    loadCultura(limit = 50, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/tipocultura/getcombo.json?limit=${limit}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    loadEmpresa() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-niveltecnologico/loadempresa`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    findAllEmpresas() {
        return this._http.get(encodeURI(`${ this._env }/agro/agro-niveltecnologico/empresa`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            return err;
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params)
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${ this._env }/agro/agro-niveltecnologico/getcombo?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            return err;
        });
    }

}